import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { GoogleOAuthProvider } from '@react-oauth/google'; 
import './index.css';
import App from './App';
import {CartProvider} from './context/CartContext'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId="1073981183203-j1a0gerpngmsmqfvpobbhdveev3n7doe.apps.googleusercontent.com">
      <CartProvider>
        <App />
      </CartProvider>
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>
);
